document.addEventListener("DOMContentLoaded", function () {
    const voucherRedeemPopup = new VoucherRedeemPopup(".redeem-your-voucher");
    voucherRedeemPopup.handleRedeemVoucherClick();
    
    // Check for voucher parameter in URL and trigger popup if present
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('voucher') === '1') {
        setTimeout(function() {
            // Trigger click on the redeem voucher link to open the popup
            document.querySelector(".redeem-your-voucher").click();
        }, 1000);
    }
});

class VoucherRedeemPopup {
    popupContentBlock;
    redeemYourVoucherLink;
    redeemVoucherContainerTemplate = $('#voucher-redeem-content-template');
    unavailableCombinationTemplate = $('#voucher-unavailable-combination-template');
    upsellContainerTemplate = $('#voucher-upsell-content-template');
    upsellListTemplate = $('#voucher-upsell-list-template');
    upsellListDiscountedTemplate = $('#voucher-upsell-list-discounted-template');
    voucherData = {};
    productSelectionData = {};
    voucherAPIData = {};
    voucherIsApplied = false;

    /**
     * Creates a new VoucherRedeemPopup instance.
     * @param redeemYourVoucherLink
     */
    constructor(redeemYourVoucherLink) {
        this.redeemYourVoucherLink = $(redeemYourVoucherLink);
        this.popupContentBlock = $(this.redeemYourVoucherLink.attr("href"));
        this.initCartVouchers().then();
    }

    /**
     * Handles the click event for the "Redeem Your Voucher" link.
     * Opens a fancybox popup with the voucher redemption form.
     * Initializes the popup with event handlers for showing and closing the popup.
     */
    handleRedeemVoucherClick = () => {
        if (!this.popupContentBlock.length) {
            console.error("Voucher redemption popup content block not found.");
            return;
        }

        this.popupContentBlock.find('.vouchercode').val('');
        this.redeemYourVoucherLink.on("click", () => {
            if (this.voucherIsApplied) {
                this.updatePopupContent(this.unavailableCombinationTemplate.html());
            } else {
                this.updatePopupContent(this.redeemVoucherContainerTemplate.html());
            }

            $.fancybox.open({
                src: this.popupContentBlock,
                type: "inline",
                opts: {
                    baseClass: "redeem-voucher-popup",
                    beforeShow: () => {
                        this.initRedeemVoucherPopup();
                    },
                    afterClose: () => {
                        this.clearErrors();
                        this.popupContentBlock.find('.action_button.redeem_button').off('click');
                        this.popupContentBlock.find('.close_btn').off('click');
                        this.popupContentBlock.find('.vouchercode').val('');
                    }
                }
            });
        });
    };

    initCartVouchers = async () => {
        return this.getCart().then(async (cart) => {
            if (cart.items.length === 0) {
                await this.removeCartVoucher();
                return;
            }

            let voucherCodes = this.getCartVouchers(cart);

            for (const voucher of voucherCodes) {
                let productForVoucherFound = false;
                for (const item of cart.items) {
                    if (item.properties._voucherCode === voucher) {
                        if (item.total_discount > 0 || item.discounts.length > 0) {
                            productForVoucherFound = true;
                        }
                    }
                }

                if (!productForVoucherFound) {
                    await this.removeCartVoucher(voucher);
                }
            }

            let lineItemId = 1;
            let forceReload = false;

            for (const item of cart.items) {
                const voucherCode = item.properties._voucherCode ?? null;
                const isChild = item.properties._child === 'child' ?? false;
                let itemProperties = item.properties ?? {};
                if (voucherCode && Array.isArray(voucherCodes) && !voucherCodes.includes(voucherCode)) {
                    await this.removeCartItemVoucher(lineItemId, itemProperties);
                    forceReload = true;
                } else {
                    if (!isChild) {
                        if (voucherCode && item.total_discount <= 0 && item.discounts.length === 0) {
                            await this.removeCartItemVoucher(lineItemId, itemProperties);
                            forceReload = true;
                        }
                    }
                }

                lineItemId++;
            }

            if (forceReload) {
                window.location.reload();
            }
        });
    };


    /**
     * Initializes the redeem voucher popup with event handlers.
     *
     */
    initRedeemVoucherPopup = () => {
        this.voucherData = {};
        this.productSelectionData = {};

        this.popupContentBlock.find('.close_btn').on('click', () => {
            $.fancybox.close();
        });
        this.popupContentBlock.find('.action_button.redeem_button').on('click', (e) => {
            e.preventDefault();
            const button = $(e.target);
            if (button.hasClass('loading')) {
                return;
            }

            button.addClass('loading');
            this.clearErrors();
            this.handleRedeemVoucher().then(() => {
                button.removeClass('loading');
            });
        });

        if (!this.popupContentBlock.find('.error_message').length) {
            this.popupContentBlock.find('.vouchercode')
                .parent()
                .after($(`<div class="error_message"></div>`));
        }
    };

    /**
     * Handles the voucher redemption process.
     *
     */
    handleRedeemVoucher = async () => {
        const voucherCode = this.popupContentBlock.find('.vouchercode').val();

        if (!voucherCode || voucherCode.trim() === '') {
            this.showError('Please enter a voucher code.');
            return;
        }

        const cart = await this.getCart();
        if (cart.attributes?.voucherCodes?.includes(voucherCode)) {
            this.showError('Voucher code has already been redeemed on this cart.');
            return;
        }

        await this.sendCheckVoucherRequest(voucherCode)
            .then((response) => {
                this.voucherAPIData = response;
                this.voucherData.voucherCode = voucherCode;
                this.processVoucherResponse(response);
            })
            .catch((error) => {
                this.showError(error.message);
            })
    }

    /**
     * Builds the upsell products popup.
     * @param product
     * @param responseData
     */
    buildUpsellProductsPopup = (product, responseData) => {
        const { featured_image, title, price, variants } = product;
        const redemptionFee = this.formatPrice(responseData.redemption_fee);

        let content = this.upsellContainerTemplate.html()
            .replace(/\$featuredImage/g, featured_image)
            .replace(/\$title/g, title)
            .replace(/\$specialPrice/g, this.formatPrice(price))
            .replace(/\$redemptionFee/g, redemptionFee);

        if (variants[0]?.available) {
            content = content.replace(/\$ctaParams/g, 'data-v-id="' + variants[0]?.id + '"')
                .replace(/\$ctaLabel/g, 'Add to Cart');
        } else {
            content = content.replace(/\$ctaParams/g, 'style="pointer-events: none"')
                .replace(/\$ctaLabel/g, 'Sold Out');
        }

        if (responseData.upsells) {
            this.getProductInfo(responseData.upsells).then((upsellProduct) => {
                const { featured_image: upsellImage, title: upsellTitle, compare_at_price: upsellSpecialPrice, price: upsellPrice, variants: upsellVariants } = upsellProduct;
                let upsellList = '';
                if (upsellSpecialPrice && upsellSpecialPrice > upsellPrice) {
                    const savedAmount = upsellSpecialPrice - upsellPrice;
                    upsellList = this.upsellListTemplate.html()
                        .replace(/\$upsellImage/g, upsellImage ?? '')
                        .replace(/\$upsellTitle/g, upsellTitle)
                        .replace(/\$upsellPrice/g, this.formatPrice(upsellPrice))
                        .replace(/\$upsellSpecialPrice/g, this.formatPrice(upsellSpecialPrice))
                        .replace(/\$upsellSavePrice/g, this.formatPrice(savedAmount))
                        .replace(/\$upsellVariantId/g, upsellVariants[0]?.id);
                } else {
                    upsellList = this.upsellListTemplate.html()
                        .replace(/\$upsellImage/g, upsellImage ?? '')
                        .replace(/\$upsellTitle/g, upsellTitle)
                        .replace(/\$upsellPrice/g, this.formatPrice(upsellPrice))
                        .replace(/\$upsellVariantId/g, upsellVariants[0]?.id);
                }

                content = content.replace(/\$upsellList/g, upsellList);
            }).finally(() => {
                this.updatePopupContent(content);
            });
        } else {
            content = content.replace(/\$upsellList/g, '');
            this.updatePopupContent(content);
        }
    };

    /**
     * Processes the voucher response and builds the upsell products popup.
     * @param response
     */
    processVoucherResponse = (response) => {
        if (response.success === true) {
            this.getProductInfo(response.handle).then((product) => {
                this.productSelectionData.mainProduct = product;
                this.buildUpsellProductsPopup(product, response);
            }).catch((error) => {
                this.showError(error.message);
            });

        } else {
            throw new Error(response.msg);
        }
    }

    /**
     * Fetches product information based on the product handle.
     *
     * @param {string} handle - The handle of the product to fetch.
     * @returns {Promise<Object>} A promise that resolves to the product information JSON object.
     * @throws {Error} If the response is not ok.
     */
    getProductInfo = async (handle) => {
        return await fetch("/products/" + handle + ".js")
            .then(response => {
                if (!response.ok) {
                    throw new Error('Something went wrong. Please contact our support.');
                }

                return response.json();
            });
    }


    /**
     * Sends a request to check the voucher code.
     *
     * @param {string} voucherCode - The voucher code to check.
     * @returns {Promise<Object>} A promise that resolves to the response JSON object.
     * @throws {Error} If the response is not ok.
     */
    sendCheckVoucherRequest = (voucherCode) => {
        return fetch(api_voucher_url + voucherCode)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Something went wrong. Please contact our support.');
                }

                return response.json();
            });
    }

    /**
     * Updates the content of the popup.
     *
     * @param {string} content - The HTML content to update the popup with.
     */
    updatePopupContent = (content) => {
        const instance = $.fancybox.getInstance();
        if (instance) {
            const container = instance.$refs?.container || instance.$content;
            if (container) {
                container.find('.redeem-voucher-container').html(content);
            }
        } else {
            this.popupContentBlock.html(content);
        }

        this.popupContentBlock.find('.close_btn').on('click', () => {
            $.fancybox.close();
        })

        this.popupContentBlock.find('input[name="upsell_checkbox"]').on('click', (e) => {
            this.productSelectionData.upsellProduct = e.target.checked ? e.target.value : null;
        });

        this.popupContentBlock.find('.action_button.voucher_code').on('click', (e) => {
            e.preventDefault();
            console.log(this.productSelectionData);
            const button = $(e.target);
            if (button.hasClass('loading')) {
                return;
            }

            button.addClass('loading');
            this.addProductsWithVoucherToCart()
                .then((addToCartResponse) => {
                    if (!addToCartResponse.ok) {
                        throw new Error('Something went wrong with adding product to cart. Please contact our support.');
                    }

                    return this.setVoucherCartAttributes();
                }).then((cartUpdateResponse) => {
                    if (!cartUpdateResponse.ok) {
                        throw new Error('Something went wrong with updating cart. Please contact our support.');
                    }

                    return this.applyDiscount();
                })
                .then(() => {
                    $.fancybox.close();
                    window.location.reload();
                })
                .catch((error) => {
                    this.showError(error.message);
                }).finally(() => {
                    button.removeClass('loading');
                });
        });
    }

    addProductsWithVoucherToCart = async () => {
        const buildUid = 'custom_build' + Math.round(new Date().getTime()/1000);
        const mainProductVariantId = this.productSelectionData.mainProduct.variants[0].id;
        const upsellProductVariantId = this.productSelectionData.upsellProduct ?? null;
        const redemptionFee = this.voucherAPIData.redemption_fee ?? 0;

        const mainProductResult = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                quantity: 1,
                id: mainProductVariantId,
                properties: {
                    Redemption_Fee: redemptionFee,
                    _custom_build: buildUid,
                    _main_product: 'yes',
                    _child: upsellProductVariantId,
                    _voucherCode: this.voucherData.voucherCode
                }
            })
        });

        if (!mainProductResult.ok) {
            throw new Error('Something went wrong with adding a main product. Please contact our support.');
        }

        if (upsellProductVariantId) {
            const childProductResult = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    quantity: 1,
                    id: upsellProductVariantId,
                    properties: {
                        _custom_build: buildUid,
                        _child: 'child',
                        _voucherCode: this.voucherData.voucherCode
                    }
                })
            });

            if (!childProductResult.ok) {
                throw new Error('Something went wrong with adding a upsell product. Please contact our support.');
            }
        }

        return await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                attributes: {
                    voucher: redemptionFee
                }
            })
        });
    }

    applyDiscount = async () => {
        const cart = await this.getCart();
        const cartVoucherCodes = this.getCartVouchers(cart);
        return await fetch('/checkout?discount=' + cartVoucherCodes.join(','), {
            method: 'GET',
            redirect: 'manual'
        });
    }


    getCart = async () => {
        return await fetch('/cart.js')
            .then(response => {
                if (!response.ok) {
                    throw new Error('Something went wrong. Please contact our support.');
                }

                return response.json();
            });
    }

    getCartVouchers = (cart) => {
        let cartVoucherCodes = cart.attributes?.voucherCodes ?? [];
        if (!Array.isArray(cartVoucherCodes)) {
            cartVoucherCodes = JSON.parse(cartVoucherCodes);
        }

        if (!Array.isArray(cartVoucherCodes)) {
            cartVoucherCodes = [];
        }

        return cartVoucherCodes;
    }

    removeCartItemVoucher = async (lineItemId, itemProperties) => {
        itemProperties.Redemption_Fee = null;
        itemProperties._voucherCode = null;

        const requestBody = JSON.stringify({
            line: lineItemId,
            properties: itemProperties
        });

        return await fetch('/cart/change.js', {
            body: requestBody,
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
    }

    removeCartVoucher = async (voucher = 'all') => {
        const cart = await this.getCart();
        let cartVoucherCodes = this.getCartVouchers(cart);
        cartVoucherCodes = (voucher === 'all')
            ? null
            : cartVoucherCodes.filter((code) => code !== voucher);

        const voucherDataRequestBody = JSON.stringify({
            attributes: {
                voucherCodes: cartVoucherCodes
            }
        });

        if (cartVoucherCodes === null || cartVoucherCodes.length === 0) {
            this.voucherIsApplied = false;
        }

        return await fetch('/cart/update.js', {
            body: voucherDataRequestBody,
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
    }

    setVoucherCartAttributes = async () => {
        const voucherCode = this.voucherData.voucherCode ?? null;
        if (!voucherCode) {
            throw new Error('Voucher code is missing.');
        }

        const cart = await this.getCart();
        let cartVoucherCodes = this.getCartVouchers(cart);
        if (cartVoucherCodes.includes(voucherCode)) {
            throw new Error('This voucher code has already been redeemed for this cart.');
        }

        cartVoucherCodes.push(voucherCode);
        const voucherDataRequestBody = JSON.stringify({
            attributes: {
                voucherCodes: cartVoucherCodes
            }
        });

        return await fetch('/cart/update.js', {
            body: voucherDataRequestBody,
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            }
        });
    }

    /**
     * Formats the price based on the money format.
     * @param price
     * @returns {*}
     */
    formatPrice = (price) => {
        const format = $('body').data('money-format');
        return Shopify.formatMoney(price, format)
    }

    /**
     * Displays an error message in the voucher popup.
     *
     * @param {string} message - The error message to display.
     */
    showError = (message) => {
        this.clearErrors();
        this.popupContentBlock.find('.error_message').html(message);
        this.popupContentBlock.find('.vouchercode').addClass('error').focus();
    }

    /**
     * Clears any error messages in the voucher popup.
     */
    clearErrors = () => {
        this.popupContentBlock.find('.error_message').empty();
        this.popupContentBlock.find('.vouchercode').removeClass('error');
    }
}





